import React, { useRef } from 'react';
import { MAIN_MENU_HEIGHT, BREAKPOINTS } from '../../ui/settings';
import { Link } from 'gatsby';
import { ThemeProvider } from 'styled-components';

import { CoursesContainer, CoursesItem } from './styles';
import Wrapper from '../../ui/Wrappers';
import Wysiwyg from '../Wysiwyg';

import { themes } from '../../ui/design-tokens';
import ButtonTertiary from '../ButtonTertiary';
import { externalLink, getSrcset } from '../../ui/helpers';

import OImage from '../OImage';
import useWindowSize from "../../hooks/useWindowSize";

interface ICourse {
  key?: string;
  color: string;
  title: string;
  description?: string;
  cta?: { uri: string; title: string };
  desktopImageUrl: any;
  mobileImageUrl: any;
  imageAlt?: string;
}

interface IProps {
  title?: string;
  description?: string;
  courses: ICourse[];
  gtmAction?: string;
  translations: any;
}

const splitInput = (input) => {
  const regex = /^([^:,\s]+)\s*[:,]?\s*(.*)/;
  const match = input.match(regex);
  if (match) {
    return [
      match[1].trim(),
      match[2].trim()
    ];
  }
  return ['', ''];
};

const CoursesPath = ({ title, description, courses, gtmAction, translations: t }: IProps) => {
  const vpSize = useWindowSize();
  const coursesLength = courses.length;
  const firstCourses = courses.slice(0, 2);
  const lastCourses = courses.slice(-2);
  var offset = 0.5;

  if (typeof window !== 'undefined') {
    const viewportHeight = window.innerHeight;

    const isMobile = window.innerWidth < 768;
    const isTablet = window.innerWidth >= 768 && window.innerWidth <= 959;

    let baseOffset;
    if (isMobile) {
      baseOffset = -0.10;
    } else if (isTablet) {
      baseOffset = -0.20;
    } else {
      baseOffset = 0.30;
    }

    const index = 0;

    offset = viewportHeight * baseOffset * (index + 1);
  }

  return (
    <CoursesContainer coursesLength={coursesLength}>
      <div className='courseSelectorContainer'>
        <span className='courseSelectorTitle'>{title}</span>
        <div className='courseSelector'>
          <div className="evenCourses">
            {firstCourses.map((course, index) => {
              const splittedCourseTitle = splitInput(course.title);

              return (
                <div className='courseWrapper' key={index}>
                  <span className={"courseText " + splittedCourseTitle[0].toLowerCase()}>{splittedCourseTitle[0]}</span>
                  <a onClick={() => {
                    if (typeof window !== 'undefined') {
                      const viewportHeight = window.innerHeight;
                      window.scrollTo({
                        top: viewportHeight * (index + 2) - offset,
                        behavior: 'smooth'
                      });
                    }
                  }}><span className='ageText'>{splittedCourseTitle[1]}</span></a>
                </div>
              )
            })}
          </div>
          <div className="oddCourses">
            {lastCourses.map((course, index) => {
              const splittedCourseTitle = splitInput(course.title);

              return (
                <div className='courseWrapper' key={index}>
                  <span className={"courseText " + splittedCourseTitle[0].toLowerCase()}>{splittedCourseTitle[0]}</span>
                  <a onClick={() => {
                    if (typeof window !== 'undefined') {
                      const viewportHeight = window.innerHeight;
                      window.scrollTo({
                        top: viewportHeight * (index + 4) - offset,
                        behavior: 'smooth'
                      });
                    }
                  }}><span className='ageText'>{splittedCourseTitle[1]}</span></a>
                </div>
              )
            })}
          </div>
        </div>
      </div>
      {courses.map((course, index) => (
        <CoursesItem position={index % 2 == 0}>
          <div className='textButtonWrapper'>
            <div className='textWrapper'>
              <span className='description'>{course.description}</span>
              <span className='title'>{course.title}</span>
            </div>
            <div className='buttonWrapper'>
              <ButtonTertiary
                to={course.cta.uri}
                target={`${externalLink(course.cta.uri) && '_blank'}`}
                label={course.cta.title}
                data-gtm-event
                data-gtm-category="cta"
                data-gtm-action={gtmAction}
                data-gtm-label={`${course.cta.title}_${course.cta.uri}`}
                noArrow
              />
            </div>
          </div>
          <img src={course.desktopImageUrl.original.href} alt="" />
        </CoursesItem>
      ))}
    </CoursesContainer>
  );
};

export default CoursesPath;
